import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchDLSurfFromS3 = async (
  authToken: string,
  study_name: string,
  cfd_id: string
): Promise<void> => {
  let url = '';
  let filePath = '';

  try {
    const { response, data } = await fetchFfdJson<{ body?: { url: string; path: string }; text?: string }>(
      `/dl_surf/download?study_name=${encodeURIComponent(study_name)}&cfd_id=${encodeURIComponent(cfd_id)}`,
      authToken
    );
    if (response.status === 200) {
      url = data.body?.url ?? "";
      filePath = data.body?.path ?? "";
    } else {
      if (data.text) alert(`${data.text}`);
      return;
    }
  } catch (error) {
    alertAuthExpired();
    return;
  }

  // ダウンロード実行
  setTimeout(() => {
    try {
      if (url !== '') {
        const fileName = filePath.split('/').pop() ?? 'dl_surf.stl';
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode!.removeChild(link);
      }
    } catch (error) {
      console.error(`Error downloading the file: ${error}`);
    }
  }, 1000);
};
